<template>
  <div class="home-container">
    <div class="hx-breadcrumb">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item>商城管理</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ name : 'mallOrderList' }">商城订单</el-breadcrumb-item>
        <el-breadcrumb-item>商城订单详情</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="hx-form-container box-shadow" v-loading="loading">
      <el-form
        ref="queryForm"
        :model="listParams"
        label-width="140px">
        <el-row :gutter="24">
          <el-col :span="8">
            <el-form-item label="用户账号：">
              <span class="alert-text">{{ listParams.userAccount }}</span>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="订单号：">
              <span class="alert-text">{{ listParams.orderNumber}}</span>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="24">
          <el-col :span="8">
            <el-form-item label="订单状态：">
              <span class="alert-text">{{ listParams.orderStatusDisplay }}</span>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="支付状态：">
              <span class="alert-text">{{ listParams.payStatusDisplay }}</span>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="24">
          <el-col :span="8">
            <el-form-item label="下单日期：">
              <span class="alert-text">{{ listParams.orderDate | formatDate(true) }}</span>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="订单总金额：">
              <span class="alert-text">{{ listParams.orderAmount }}</span>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="24">
          <el-col :span="8">
            <el-form-item label="商品数量：">
              <span class="alert-text">{{ listParams.goodsNumber }}</span>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="供应商家：">
              <span class="alert-text">{{ listParams.supplier }}</span>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="24">
          <el-col :span="8">
            <el-form-item label="退款总金额：">
              <span class="alert-text">{{ listParams.returnAmount }}</span>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="收货地址：">
              <span class="alert-text">{{ listParams.receiveAddress }}</span>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>

    <div class="hx-form-container box-shadow">
      <div class="pictures-display">
        <img
          :src="item"
          alt=""
          v-for="(item, index) in listParams.goodsPictures"
          :key="index">
      </div>
    </div>

    <hx-table-result
      :show-pager-on-one-page="false"
      :loading="false">
      <el-table
        slot="content"
        :data="listParams.goodsList"
        max-height="800"
        border>

        <el-table-column
          prop="goodName"
          align="center"
          label="商品名称">
        </el-table-column>

        <el-table-column
          prop="goodSpec"
          align="center"
          label="商品规格">
        </el-table-column>

        <el-table-column
          prop="goodsNumber"
          align="center"
          label="购买数量">
        </el-table-column>

        <el-table-column
          prop="returnNumber"
          align="center"
          label="退货数量">
        </el-table-column>

        <el-table-column
          prop="goodsAmount"
          align="center"
          label="商品总额">
          <template slot-scope="scope">
            ¥ {{ scope.row.goodsAmount }}
          </template>
        </el-table-column>

        <el-table-column
          prop="returnAmount"
          align="center"
          label="退货总额">
          <template slot-scope="scope">
            ¥ {{ scope.row.returnAmount }}
          </template>
        </el-table-column>
      </el-table>
    </hx-table-result>

    <div style="width: 100%;text-align: center;margin-top: 10px;">
      <el-button
        style="width: 120px;"
        v-if="listParams.orderStatusValue === 2"
        size="small"
        type="primary"
        @click="deliverItem(orderId)">
        发货
      </el-button>

      <el-button
        style="width: 120px;"
        v-if="listParams.orderStatusValue === 3"
        size="small"
        type="danger"
        @click="receiveItem(orderId)">
        收货
      </el-button>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
export default {
  data () {
    return {
      orderId: '',
      listParams: {
        userAccount: '',
        orderNumber: '',
        orderStatusDisplay: '',
        orderStatusValue: '',
        payStatusDisplay: '',
        orderDate: '',
        orderAmount: '',
        goodsNumber: '',
        supplier: '',
        returnAmount: '',
        receiveAddress: '',
        goodsPictures: [],
        goodsList: []
      },
      loading: false
    };
  },
  mounted () {
    const hash = window.location.hash;
    if (hash.indexOf('=') > -1) {
      this.orderId = hash.substring(hash.indexOf('=') + 1, hash.length);
      this.loadDetailData(this.orderId);
    }
  },
  methods: {
    /**
       * 加载详情数据
       * @param orderId
       */
    loadDetailData (orderId) {
      Vue.ajaxGet(this, global.apiUrl + '/order/mall/detail', { orderId: orderId }).then((res) => {
        Object.assign(this.listParams, res);
      });
    },
    /**
       * 发货
       * @param orderId
       */
    deliverItem (orderId) {
      Vue.ajaxPost(this, global.apiUrl + '/order/mall/send', { orderId: orderId }, true, true).then((res) => {
        this.$message.success(res.info);
        this.loadDetailData(this.orderId);
      });
    },
    /**
       * 收货
       * @param orderId
       */
    receiveItem (orderId) {
      Vue.ajaxPost(this, global.apiUrl + '/order/mall/receive', { orderId: orderId }, true, true).then((res) => {
        this.$message.success(res.info);
        this.loadDetailData(this.orderId);
      });
    }
  }
};
</script>

<style lang="less" scoped>
  .home-container{
    .alert-text{
      color: #E9A021;
      cursor: default;
    }
    .pictures-display{
      width: 100%;
      height: 220px;
      overflow: hidden;
      img{
        width: 200px;
        height: 200px;
        margin-top: 10px;
        margin-left: 10px;
      }
    }
  }
</style>
